import { IServiceEnablementResponse as IBenefitsServiceEnablementResponse } from "@wingspanhq/benefits/dist/lib/interfaces/api/service";
import {
  ITransaction,
  WSCategory
} from "@wingspanhq/bookkeeping/dist/lib/interfaces";
import { WSIconName } from "@wingspanhq/fe-component-library";
import {
  IInvoice,
  IServiceStatusResponse
} from "@wingspanhq/payments/dist/interfaces";
import {
  IActivity,
  IActivityEvents,
  IClient,
  IMember,
  INewUser,
  ToDoStatus
} from "@wingspanhq/users/dist/lib/interfaces";
import { BookkeepingEnablement } from "../../services/bookkeeping";

export interface DashboardToDosInputType {
  member: IMember;
  user: INewUser;
  client: IClient;
  activities: IActivity;
  paymentsStatus: IServiceStatusResponse;
  bookkeepingStatus: BookkeepingEnablement;
  benefitsStatus: IBenefitsServiceEnablementResponse;
}

export enum TodoCategory {
  General = "General",
  DocumentsToSign = "DocumentsToSign"
}

export enum WSAppFeatures {
  Payments = "Payments",
  Bookkeeping = "Bookkeeping",
  Benefits = "Benefits",
  FileVault = "FileVault",
  Business = "Business",
  Profile = "Profile"
}

export interface IDashboardToDo {
  title: string;
  description: string;
  icon: WSIconName;
  status: ToDoStatus;
  onClick: () => void | Promise<void>;
  category: TodoCategory;
  feature?: WSAppFeatures;
  canMarkAsDone?: boolean;
  activityEventName?: keyof IActivityEvents;
}

export function getSendYourFirstInvoiceToDoStatus(
  invoices: IInvoice[],
  activity: IActivity
) {
  if (activity.flows.paymentsSetup?.complete && invoices.length > 0) {
    return ToDoStatus.Completed;
  } else if ((activity.flows.paymentsSetup?.currentStep as number) > 1) {
    return ToDoStatus.InProgress;
  }
  return ToDoStatus.ToDo;
}

export function getAddYourFirstIncomeTransactionToDoStatus(
  transactions: ITransaction[],
  activity: IActivity
) {
  const hasIncomeTxn =
    transactions.filter(txn => txn.wsCategory === WSCategory.Income).length > 0;
  if (
    !activity.flows.paymentsSetup?.complete &&
    !activity.flows.bookkeepingSetup?.complete
  ) {
    return ToDoStatus.ToDo;
  } else if (hasIncomeTxn) {
    return ToDoStatus.Completed;
  }
  return ToDoStatus.InProgress;
}

export function getActivateTeladocToDoStatus(activity: IActivity) {
  if (activity.flows.benefitsSetup?.complete) {
    return ToDoStatus.Completed;
  } else if ((activity.flows.benefitsSetup?.currentStep as number) > 1) {
    return ToDoStatus.InProgress;
  }
  return ToDoStatus.ToDo;
}

export function groupTasksByCategory(tasks: IDashboardToDo[]) {
  return tasks.reduce<
    {
      [key in TodoCategory]?: IDashboardToDo[];
    }
  >(
    (categories, task) => ({
      ...categories,
      [task.category]: [...(categories[task.category] || []), task]
    }),
    {}
  );
}
